import { PRESENTE, PRESENTE_FAIL, PRESENTE_SUCCESS } from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsPostAsignarPresente =
  (idTurno, sectorTurno, nextStep) => (dispatch) => {
    dispatch({ type: PRESENTE });

    axiosLogin().then((respuesta) => {
      respuesta
        .post(`his/turnos/asignarPresente/${idTurno}/${sectorTurno}`)
        .then((resp) => {
          dispatch({ type: PRESENTE_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(true);
        })
        .catch((err) => {
          dispatch({ type: PRESENTE_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(false);
        });
    });
  };
